var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDateFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lets-icons:date-fill",
    transform: "translate(1.1667 1.6667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 5.83333C0 4.26167 -4.96705e-08 3.47667 0.488333 2.98833C0.976667 2.5 1.76167 2.5 3.33333 2.5H13.3333C14.905 2.5 15.69 2.5 16.1783 2.98833C16.6667 3.47667 16.6667 4.26167 16.6667 5.83333C16.6667 6.22583 16.6667 6.4225 16.545 6.545C16.4225 6.66667 16.225 6.66667 15.8333 6.66667H0.833333C0.440833 6.66667 0.244167 6.66667 0.121667 6.545C-7.45058e-08 6.4225 0 6.225 0 5.83333ZM0 13.3333C0 14.905 -4.96705e-08 15.69 0.488333 16.1783C0.976667 16.6667 1.76167 16.6667 3.33333 16.6667H13.3333C14.905 16.6667 15.69 16.6667 16.1783 16.1783C16.6667 15.69 16.6667 14.905 16.6667 13.3333V9.16667C16.6667 8.77417 16.6667 8.5775 16.545 8.455C16.4225 8.33333 16.225 8.33333 15.8333 8.33333H0.833333C0.440833 8.33333 0.244167 8.33333 0.121667 8.455C-7.45058e-08 8.5775 0 8.775 0 9.16667V13.3333Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16699 0.833333V3.33333M12.5003 0.833333V3.33333",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDateFill);
export default __webpack_public_path__ + "static/media/icon-date-fill.1624deaf5d514f5cf7a45f500cd7da49.svg";
export { ForwardRef as ReactComponent };